{
    "Capability": "Capability",
    "CapabilityEnabled": "Enabled",
    "AvailableTelServers": "Which Telephony Server types are available?",
    "AvailableLicences": "Which Site Licence types are available?",
    "Broadworks": "Cisco Broadworks",
    "Webex": "Webex Calling",
    "LegacyTelephony": "Legacy ^^(Broadsoft M6, Panasonic, Siemens)^^",
    "Legacy": "Legacy ^^(ONE, Presence, Lite, 1000, 2000)^^",
    "Enterprise": "Enterprise",
    "Teams": "MS Teams",
    "MaxTelsysCount": "Maximum number of Telephony Servers in this CME",
    "CxAnalytics": "CX Analytics",
    "CxIntegration": "CX Integration",
    "NAME": "CMECapabilities"
}
